import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './NormalInput.css';

class NormalInput extends Component {
  render() {
    const {
      defaultText,
      value,
      maxlength,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      style,
      className,
      colorClassName,
      textAlign,
      placeholder,
      autofocus,
      inputRef,
      disabled
    } = this.props;
    const classSet = classnames(
      'normalinput-input',
      colorClassName,
      {
        'normalinput-input-right': textAlign === 'right'
      },
      {
        'normalinput-input-left': textAlign === 'left'
      },
      {
        disabledText: disabled
      },
      className
    );
    return (
      <input
        ref={inputRef}
        style={style}
        className={classSet}
        defaultValue={defaultText}
        value={value || undefined}
        maxLength={maxlength}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        autoFocus={autofocus}
        disabled={disabled}
      />
    );
  }
}

NormalInput.propTypes = {
  value: PropTypes.string,
  defaultText: PropTypes.string,
  maxlength: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
  colorClassName: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  textAlign: PropTypes.oneOf(['right', 'left']),
  placeholder: PropTypes.string,
  autofocus: PropTypes.bool,
  inputRef: PropTypes.func,
  disabled: PropTypes.bool
};

NormalInput.defaultProps = {
  value: undefined,
  defaultText: '',
  placeholder: '',
  maxlength: -1,
  style: {},
  className: '',
  colorClassName: 'theme--color-primary',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onKeyDown: () => {},
  textAlign: 'left',
  autofocus: false,
  inputRef: null,
  disabled: false
};

export default NormalInput;
